(function () {
  'use strict';

  var assetBase = 'https://cdn.shopify.com/extensions/01a066c1-7258-7861-94a0-7a17a54f35cd/wishlist-hero-94/assets/';
  var loadPromise = null;

  function loadScript(url, name) {
    var existingScript = document.querySelector('script[data-wishlist-hero-lazy="' + name + '"]');

    if (existingScript) {
      if (existingScript.dataset.loaded === 'true') return Promise.resolve();

      return new Promise(function (resolve, reject) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.wishlistHeroLazy = name;
      script.onload = function () {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadStylesheet() {
    if (document.querySelector('link[data-wishlist-hero-lazy-style]')) return;

    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = assetBase + 'default.css';
    stylesheet.dataset.wishlistHeroLazyStyle = 'true';
    document.head.appendChild(stylesheet);
  }

  function configureWishlistHero() {
    window._wh_asset_path = assetBase;
    window.WishListHero_block_settings = window.WishListHero_block_settings || {};
    window.WishListHero_block_settings.customLoginUrl = '/account/login';
  }

  function bindArrive() {
    if (!document.arrive || window.__wishlistHeroLazyArriveBound) return;

    window.__wishlistHeroLazyArriveBound = true;
    document.arrive('.wishlist-hero-custom-button', function (wishlistButton) {
      var event = new CustomEvent('wishlist-hero-add-to-custom-element', {
        detail: wishlistButton
      });
      document.dispatchEvent(event);
    });
  }

  function loadWishlistHero() {
    if (loadPromise) return loadPromise;

    configureWishlistHero();
    loadStylesheet();
    loadPromise = loadScript(assetBase + 'default.js', 'default')
      .then(function () {
        return loadScript(assetBase + 'bundle2.js', 'bundle');
      })
      .then(function () {
        return loadScript(assetBase + 'arrive.min.js', 'arrive');
      })
      .then(bindArrive);

    return loadPromise;
  }

  function replayHeartClick(container) {
    var attempts = 0;

    function findRenderedButton() {
      var button = container.querySelector('button:not([data-wishlist-hero-placeholder])');
      if (button) {
        window.__wishlistHeroReplayClick = true;
        button.click();
        window.__wishlistHeroReplayClick = false;
        return;
      }

      if (attempts < 80) {
        attempts += 1;
        window.setTimeout(findRenderedButton, 50);
      } else {
        container.removeAttribute('data-wishlist-hero-activating');
      }
    }

    findRenderedButton();
  }

  document.addEventListener('click', function (event) {
    if (window.__wishlistHeroReplayClick) return;

    var target = event.target;
    var container = target && target.closest ? target.closest('.wishlist-hero-custom-button') : null;
    if (!container || container.dataset.wishlistHeroActivated === 'true' || container.dataset.wishlistHeroActivating === 'true') return;

    event.preventDefault();
    container.dataset.wishlistHeroActivating = 'true';

    loadWishlistHero()
      .then(function () {
        container.dataset.wishlistHeroActivated = 'true';
        container.removeAttribute('data-wishlist-hero-activating');
        replayHeartClick(container);
      })
      .catch(function () {
        container.removeAttribute('data-wishlist-hero-activating');
      });
  }, true);
})();
